import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { catchError, EMPTY, Observable } from "rxjs";
import { AppErrorService } from "../error/app-error.service";
import { AppErrorCode } from "@model";

@Injectable({ providedIn: "root" })
export class AppHttpService {
  constructor(
    private _http: HttpClient,
    private _appErrorService: AppErrorService,
  ) {}

  makeGETRequest<T>(
    url: string,
    params: unknown = {},
    allowedErrorStatuses: number[] = [],
  ): Observable<T> {
    return this._http.get<T>(url, { params: params as HttpParams }).pipe(
      catchError((e: HttpErrorResponse) => {
        if (e.status !== 401 && !allowedErrorStatuses.includes(e.status)) {
          this._setAppError();
          console.warn(`failed to load: ${url}`, e);
          return EMPTY;
        } else {
          throw e;
        }
      }),
    );
  }

  makePOSTRequest<T>(url: string, data = {}, params: unknown = {}): Observable<T> {
    return this._http.post<T>(url, data, { params: params as HttpParams }).pipe(
      catchError((e) => {
        if (e.status !== 401) {
          this._setAppError();
          console.warn(`failed to load: ${url}`, e);
          return EMPTY;
        } else {
          throw e;
        }
      }),
    );
  }

  private _setAppError() {
    this._appErrorService.setError(AppErrorCode.LOADING_ERROR);
  }
}
